<template>
	<div class="content">
		<div class="content_head">
			<select v-model="areaID" v-if="$store.state.user.UserType==0" @change="selectArea">
				<option v-for="(i,index) in $store.state.area" :value="i.areaID">{{i.areaName}}</option>
			</select>
			
			<select v-model="ShopID" title="选择店铺" @change="pageIndex=1;getData()" v-if="$store.state.user.UserType==0">
				<option v-for="i in Shop" :value="i.ShopID"  >
					{{i.ShopName}}
				</option>
			</select>
			
			<input type="text" placeholder="扫描客户二维码|输入手机号" class="search" v-model="search"
				@keypress.enter="pageIndex=1;getData()" />
			&nbsp;&nbsp;
			<input type="text" v-model="beginData" class="search" placeholder="开始时间(格式:2021-01-01)" />
			~
			<input type="text" v-model="endTime" class="search" placeholder="结束时间(格式:2021-01-01)" />
			<button type="button" class="button " @click="pageIndex=1;getData()">查找</button>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th class="left">客户信息</th>
						<th class="left">订单信息</th>
						<th class="left">付费信息</th>
						<th class="left">订单类型</th>
						<th>订单相关详情</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in orders">
						<td>
							{{index+1+ (pageIndex-1)*pageRows}}
						</td>
						<td class="left">
						{{'姓名:'+i.CustomerName}}<br />
							{{'手机:'+i.CustomerPhone}}
							 
						</td>
					
						<td class="left red">
							{{'编号:'+i.OrderCode}}<br />
							{{'时间:'+i.OrderDate}}<br />
							{{'数量:'+i.BookNums}}<br />
						</td>
						<td class="left red">
							{{'应付运费:'+i.FreightMoney+'元'}}<br />
							{{'实付运费:'+i.ActualPayment+'元'}}<br />
							{{'阅读费用:'+i.ReadMoney+'元'}}<br />
						</td>
						<td class="left">
							{{'类型:'+orderstype(i.OrderType)}}<br />
							{{'状态:'+orderstate(i.OrderState,i.OrderType)}}<br />
						</td>
						<td>
							<button type="button" class="button"
								@click="$router.replace('/orderQuery/orderDetail/'+i.CustomerOrderID)">订单图书详情</button>
							<br />
							<button type="button" class="button" @click="$router.replace('/orderQuery/orderHistory/'+i.CustomerOrderID)">订单操作记录</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="foot_pages">
			<span class="red">{{"合计:"+count+'条订单'}}</span>
			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>
			<select v-model="pageRows" @change="changePageRows">
				<option value="5">5/页</option>
				<option value="10">10/页</option>
				<option value="15">15/页</option>

			</select>
			<button class="button"  :class="{'disabled':down}" :disabled="down" @click="changePages('down')">下一页</button>
		</div>

	</div>

</template>

<script>
	import j from './orderQuery.js'
	export default j
</script>

<style>

</style>
